import { render, staticRenderFns } from "./DeliveryType.vue?vue&type=template&id=76359d35&scoped=true&"
import script from "./DeliveryType.vue?vue&type=script&lang=js&"
export * from "./DeliveryType.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryType.vue?vue&type=style&index=0&id=76359d35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76359d35",
  null
  
)

export default component.exports